module.exports = __webpack_public_path__ + "static/media/13.2ae30e6b.jpg";